// components/common/Sidebar.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({
  isOpen,
  onClose,
  activeMenu = "business",
  onMenuChange,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      id: "business",
      label: "Business",
      icon: "bi-building",
      path: "/business",
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bi-speedometer2",
      path: "/dashboard",
    },
    {
      id: "transaction",
      label: "Transaction",
      icon: "bi-arrow-left-right",
      path: "/transaction",
    },
  ];

  const handleMenuClick = (item) => {
    // Navigate to the path
    navigate(item.path);

    // Call the onMenuChange callback if provided
    if (onMenuChange) {
      onMenuChange(item.id);
    }

    // Close the sidebar on mobile
    if (onClose) {
      onClose();
    }
  };

  // Determine active menu based on current path if not provided
  const getActiveMenu = () => {
    if (activeMenu) return activeMenu;

    const path = location.pathname;
    if (path === "/business" || path === "/") return "business";
    if (path === "/dashboard") return "dashboard";
    if (path === "/transaction") return "transaction";
    return "business";
  };

  const currentActive = getActiveMenu();

  return (
    <>
      {/* Sidebar Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-header">
          <img
            src="/logo/Paynuts-logo-2026.png"
            alt="PayNuts"
            className="sidebar-logo"
          />
        </div>

        <div className="sidebar-menu">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className={`sidebar-menu-item ${currentActive === item.id ? "active" : ""}`}
              onClick={() => handleMenuClick(item)}
            >
              <i className={`bi ${item.icon} me-2`}></i>
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
